import React, { Component } from 'react';
import WelcomeScreen from './WelcomeScreen';
import Quiz from './Quiz';
import Results from './Results';
import ErrorPage from './ErrorPage'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import '../assets/css/styles.css';

class App extends Component {
  render() {
    return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={WelcomeScreen} />
        <Route path="/quiz" component={Quiz} />
        <Route path="/results/:resultId" component={Results} />
        <Route component={ErrorPage} />
      </Switch>
    </BrowserRouter>
    )
  }
}


export default App;